import { Breadcrumb as AntdBreadcrumb, Skeleton } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Breadcrumb = styled(AntdBreadcrumb)`
  &.ant-breadcrumb {
    ol {
      li {
        &:has(.ant-skeleton) {
          padding-top: 2px;
        }

        :last-child {
          font-size: 1.25rem;
        }
      }

      .ant-breadcrumb-separator {
        font-size: 1.25rem;
      }
    }
  }
`;

export const StyledLink = styled(Link)`
  font-size: 1.25rem;
`;

export const StyledTitle = styled.span`
  font-size: 1.25rem;
`;

export const StyledSkeleton = styled(Skeleton)`
  &.ant-skeleton {
    display: inline;
    vertical-align: text-top;
  }
  .ant-skeleton-content .ant-skeleton-title {
    margin: 0;
  }
`;
